import api from "../Api.js";

export default () => {
  // TODO
  async function getClientes() {
    return await api().get("/config/cliente-info/");
  }

  async function getInformacoes(cliente) {
    return await api().get(`/config/cliente-info/${cliente}`);
  }

  async function setInformacoes(cliente) {
    return await api().put("/config/cliente-info", cliente);
  }

  async function getImagem(path, cliente) {
    return await api().get(`/config/cliente-info/imagem/${path}/${cliente}`);
  }

  async function setImagem(path, imagem) {
    return await api().put(`/config/cliente-info/imagem/${path}`, imagem);
  }

  // TODO
  async function getServicoDisponivel(cliente) {
    return await api().get(
      `/config/cliente-info/servico-disponivel/${cliente}`
    );
  }

  return {
    getClientes,
    getInformacoes,
    setInformacoes,
    getImagem,
    setImagem,
    getServicoDisponivel
  };
};
